import { Action } from '@reduxjs/toolkit'
import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

export const actionTypes = {
  GetSearchTableData: '[GetSearchTableData] Action',
  GetSearchTranslateData: '[GetSearchTranslateData] Action',
  SetPartnerOptions: '[SetPartnerOptions] Action',
  SetCompanyId: '[SetCompanyId] Action',
}

const initialSearchState: ISearchState = {
  columnList: [],
  columnValues: [],
  definitions: [],
  serverStatus: [],
  de: [],
  en: [],

  partnerOptions: [],

  companyId: ""
}

export interface ISearchState {
  columnList: [],
  columnValues: [],
  definitions: [],
  serverStatus: [],
  partnerOptions: [],
  de: [],
  en: [],

  companyId: string;
}

export const reducer = persistReducer(
  { storage, key: 'portal-search', whitelist: ['columnList', 'columnValues', 'definitions', 'serverStatus', 'de', 'en', 'companyId'] },
  (state: ISearchState = initialSearchState, action: any) => {
    switch (action.type) {
      case actionTypes.GetSearchTableData: {
        const columnValues = JSON.parse(action.payload.data.data);
        let headers = JSON.parse(action.payload.data.headers);
        let definitions = JSON.parse(action.payload.data.definitions);
        let serverStatus = JSON.parse(action.payload.data.serverStatus);
        let columnList: any = [];

        headers.forEach((element: any) => {
          let newElement: any = [...Object.values(element)]
          columnList.push(newElement[0]);
        });
        return { ...state, columnList, columnValues, definitions, serverStatus };
      }
      case actionTypes.GetSearchTranslateData: {
        const de = JSON.parse(action.payload.data.de);
        const en = JSON.parse(action.payload.data.en);
        return { ...state, de, en };
      }
      case actionTypes.SetCompanyId: {
        const companyId = action.payload.data;
        return { ...state, companyId };
      }
      case actionTypes.SetPartnerOptions: {
        let partners = JSON.parse(action.payload.data.partners);
        // eslint-disable-next-line
        partners = partners.sort((a: any, b: any) => {
          if (a['partner'] && b['partner']) {
            return a['partner'].toLowerCase() < b['partner'].toLowerCase() ? -1 : 1;
          }
        });
        return { ...state, partnerOptions: partners };
      }
      default:
        return state
    }
  }
)

export const actions = {
  getSearchTableData: (data: any) => ({ type: actionTypes.GetSearchTableData, payload: { data } }),
  setPartnerOptions: (data: any) => ({ type: actionTypes.SetPartnerOptions, payload: { data } }),
  getTranslateData: (data: any) => ({ type: actionTypes.GetSearchTranslateData, payload: { data } }),
  setCompanyId: (data: any) => ({ type: actionTypes.SetCompanyId, payload: { data } }),
  store: () => ({ type: "def" }),
}

export function* saga() {

}
